import React from 'react'
import { createRoot } from 'react-dom/client'
import '@ant-design/v5-patch-for-react-19'
import { ApolloProvider } from '@apollo/client'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import isBetween from 'dayjs/plugin/isBetween'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/th'
import { client } from '../config/apolloClient/client'
import { configureStore } from './redux/store'
import App from './components/App'

dayjs.extend(relativeTime)
dayjs.extend(isBetween)
dayjs.extend(advancedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(duration)
dayjs.extend(localizedFormat)

export const store = configureStore(window.__INITIAL_STATE__)

const MOUNT_NODE = document.getElementById('root')

if (!__TEST__) {
  const root = createRoot(MOUNT_NODE)
  root.render(
    <ApolloProvider client={client}>
      <App store={store} />
    </ApolloProvider>
  )
}
